import {Injectable, Optional, SkipSelf} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {noop} from "rxjs";

type ShouldReuseRoute = (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) => boolean;

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  private initialized = false;

  get currentLocale(): string {
    if (this.translate.getActiveLang() === null || this.translate.getActiveLang === undefined) {
      return this.translate.getDefaultLang()
    }
    return this.translate.getActiveLang();
  }

  constructor(
    private router: Router,
    private translate: TranslocoService,
    @Optional()
    @SkipSelf()
      otherInstance: LocaleService,
  ) {
    if (otherInstance) throw new Error('LocaleService should have only one instance.');
  }


  setLocale(localeId: string) {
    this.translate.setActiveLang(localeId);
  }

}
